const CalculateSumOfActualValues = (values, setFieldValue, parentIndex) => {
  // Initialize total sum for N, P, K, S across all placements
  let totalSum = { N: 0, P: 0, K: 0, S: 0 };

  // Iterate through fertility placements of the specific crop (using parentIndex)
  const summedData = values?.data?.[parentIndex]?.fertility?.map(
    (placement, index) => {
      const actualTotalValue = placement.products?.reduce(
        (sum, productData) => {
          if (productData?.actualValue) {
            const actualValues = productData.actualValue.split("-").map(Number);
            sum.N += actualValues[0] || 0;
            sum.P += actualValues[1] || 0;
            sum.K += actualValues[2] || 0;
            sum.S += actualValues[3] || 0;
          }
          return sum;
        },
        { N: 0, P: 0, K: 0, S: 0 }
      );

      // Format summed total as "N-P-K-S"
      const actualTotalValueString = `${actualTotalValue.N}-${actualTotalValue.P}-${actualTotalValue.K}-${actualTotalValue.S}`;

      // Update Formik state with the calculated actualTotalValue for this placement
      setFieldValue(
        `data[${parentIndex}].fertility[${index}].actualTotalValue`,
        actualTotalValueString
      );

      // Update total sum
      totalSum.N += actualTotalValue.N;
      totalSum.P += actualTotalValue.P;
      totalSum.K += actualTotalValue.K;
      totalSum.S += actualTotalValue.S;

      return actualTotalValue;
    }
  );

  // Store summed actualTotalValue as totalFertilizerNutrients
  const totalFertilizerNutrients = `${totalSum.N}-${totalSum.P}-${totalSum.K}-${totalSum.S}`;
  setFieldValue(
    `data[${parentIndex}].totalFertilizerNutrients`,
    totalFertilizerNutrients
  );

  // Calculate totalNutrients by adding soilTest values
  const totalFertilizerValues = totalFertilizerNutrients.split("-").map(Number);
  const soilTestValues = [
    parseFloat(values.data[parentIndex].soilTest.N) || 0,
    parseFloat(values.data[parentIndex].soilTest.P) || 0,
    parseFloat(values.data[parentIndex].soilTest.K) || 0,
    parseFloat(values.data[parentIndex].soilTest.S) || 0,
  ];

  // Sum fertilizer and soil test values
  const totalNutrients = totalFertilizerValues.map(
    (fertilizer, index) => fertilizer + soilTestValues[index]
  );

  // Format total nutrients as "N-P-K-S"
  const totalNutrientsString = `${totalNutrients[0]}-${totalNutrients[1]}-${totalNutrients[2]}-${totalNutrients[3]}`;
  setFieldValue(`data[${parentIndex}].totalNutrients`, totalNutrientsString);

  return totalFertilizerNutrients; // Return the total sum of fertilizer nutrients as a string
};
const CalculateActualValue = (
  placementIndex,
  productIndex,
  soilTest,
  values,
  setFieldValue,
  parentIndex
) => {
  if (
    !values?.data?.[parentIndex]?.fertility?.[placementIndex]?.products?.[
      productIndex
    ]
  ) {
    console.error("Invalid fertility or product index");
    return;
  }

  const product =
    values?.data[parentIndex].fertility[placementIndex].products[productIndex];
  const rate = parseFloat(product?.rate) || 0; // Ensure rate is treated as a number

  if (!soilTest) {
    console.error("Invalid soil test data");
    return;
  }

  // Extract soilTest values, defaulting to 0 if undefined
  const { N = 0, P = 0, K = 0, S = 0 } = soilTest;

  // Calculate actual values for N, P, K, S based on the rate and soil test
  const actualValues = {
    N: (rate * N) / 100,
    P: (rate * P) / 100,
    K: (rate * K) / 100,
    S: (rate * S) / 100,
  };

  // Construct the actual value string (rounded to nearest whole number)
  const actualString = `${Math.round(actualValues.N)}-${Math.round(
    actualValues.P
  )}-${Math.round(actualValues.K)}-${Math.round(actualValues.S)}`;

  // Update Formik state with the new actual value string
  setFieldValue(
    `data[${parentIndex}].fertility[${placementIndex}].products[${productIndex}].actualValue`,
    actualString
  );
};

export { CalculateSumOfActualValues, CalculateActualValue };
